import script from "./funzionalita.vue?vue&type=script&setup=true&lang=js"
export * from "./funzionalita.vue?vue&type=script&setup=true&lang=js"

import "./funzionalita.vue?vue&type=style&index=0&id=3773686a&lang=css"

const __exports__ = script;

export default __exports__